import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InsuredMainService {
  constructor(private readonly http: HttpClient) {}
  getDisclosureData(): Observable<any> {
    return this.http.get('assets/data/pip/insured.json');
  }
}
